<template>
  <div class="size-range-inputs">
    <div class="input-box">
      <span>横版</span>
      <el-input @input="emits('input', inputValue)" v-model="inputValue.previewValue">
        <template #append> <span>px</span></template>
      </el-input>
    </div>

    <div class="input-box">
      <span>竖版</span>
      <el-input @input="emits('input', inputValue)" v-model="inputValue.nextValue">
        <template #append> <span>px</span></template>
      </el-input>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'

// eslint-disable-next-line
const props = defineProps({
  value: {
    type: Object
  }
})

// eslint-disable-next-line
const emits = defineEmits(['input'])

const inputValue = ref(props.value)
</script>

<style lang="scss" scoped>
.size-range-inputs {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 12px;

  .input-box {
    display: flex;
    align-items: center;
    flex-basis: 45%;
    span {
      white-space: nowrap;
    }
  }
}
</style>
